import type { IngestionRun } from "../IngestionRun";

export const LATEST_RUNS_POLL_MS = 15_000;

/**
 * When to reread the latest runs: every {@link LATEST_RUNS_POLL_MS} while a
 * run is running, or while a file in `expectRunBy` has no run and its time
 * (ms since the epoch) is still ahead of `now`; otherwise never.
 */
export function latestRunsRefetchInterval(
  runs: Readonly<Record<string, IngestionRun>> | undefined,
  expectRunBy: Readonly<Record<string, number>>,
  now: number,
): number | false {
  if (runs === undefined) {
    return false;
  }
  const running = Object.values(runs).some((run) => run.status === "running");
  const awaitingFirstRun = Object.entries(expectRunBy).some(
    ([fileId, deadline]) => runs[fileId] === undefined && now < deadline,
  );
  return running || awaitingFirstRun ? LATEST_RUNS_POLL_MS : false;
}
